import { Aplicacao } from '.';
import { IntegracaoStatus } from '../../integracao/integracao-status.enum';
import { PagamentoStatus } from '../../payment/pagamento-status.enum';

export class Bs2IntegracaoDto {
  id: string;
  bs2Id: string;
  bs2Numero: number;
  pagamentoId: string;
  valor: number;
  codigoDeBarras?: string;
  linhaDigitavel?: string;
  boletoPdf?: string;
  pagamentoStatus: PagamentoStatus;
  valorPago?: number;
  dataPagamento?: Date;
  dataVencimento: Date;
  dataEmissao: Date;
  parcela: number;
  parcelas: number;
  atendimentoId: string;
  dataCriacao?: Date;
  dataAtualizacao?: Date;
  status: IntegracaoStatus;
  statusBs2: IntegracaoStatus;
  dataCancelamentoEfetuado?: Date;
  justificativaCancelamento?: string;
  aplicacao: Aplicacao;
}
